export const colors = {
  primary: "#0013C1",
  primaryDark: "#00158E",
  primaryLight: "##2441E4",

  secondary: "#F2A516",
  secondaryDark: "#EF9506",
  secondaryLight: "#F4AE3D",

  white: "#FFFFFF",
  background: "#F6F6F6",
  gray: "#707070",
  darkGray: "#46485A",
  black: "#000000",

  error: "#EB5757",
  success: "#56C568",
  info: "#3FA2F7",
  warning: "#FFF250",

  errorLight: "#EF9595",
  successLight: "#96D8A0",
  infoLight: "#88C3F6",
  warningLight: "#F8F4C2",

  disabled: "#D1D3D5",
  grayDetails: "#D1D3D5",
};
